export const handleDiceEmailInput = (
  setCamerasObject: any,
  camerasObject: any,
  inputString: any,
  objectId: number
) => {
  const newObject = camerasObject[objectId];

  newObject.dice.dice_email = inputString;

  setCamerasObject((previousState: any) => {
    return { ...previousState, objectId: newObject };
  });
};
